import React from "react";
import Button from "@material-ui/core/Button";
import { FastField, Field } from "formik";

export default ({
  children,
  fast = true,
  FieldComponent = fast ? FastField : Field,

  ...props
}) => {
  return (
    <FieldComponent>
      {({ form: { isSubmitting, isValidating, resetForm, dirty } }) => {
        const disabled = isSubmitting || isValidating || !dirty;
        const reset = () => {
          resetForm();
        };

        return (
          <Button type="reset" {...props} disabled={disabled} onClick={reset}>
            {children}
          </Button>
        );
      }}
    </FieldComponent>
  );
};
